import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmAuthAccountClosedError } from '@/core/error/transport/auth/TmAuthAccountClosedError'
import { oauthEndpointProvidersPredicateFn } from '@/services/transport/errorsProcessing/rules/oauth/types'

export const oauthAccountClosedErrorRule: CustomErrorRule = {
  predicateFn: oauthEndpointProvidersPredicateFn,
  subCodes: ['auth.account_closed'],
  klass: TmAuthAccountClosedError,
}
